/**
 * =========================================================
 * ✅ SUBJECT NAME
 * =========================================================
 */
export function getSubjectLabel(subjectName) {
  return SUBJECT_LABELS[subjectName] ?? subjectName;
}

/**
 * =========================================================
 * ✅ SUBJECT CATEGORIES
 * =========================================================
 */
export const SUBJECT_CATEGORIES = {
  Sprachen: [
    "Deutsch",
    "Englisch",
    "Französisch",
    "Spanisch",
    "Italienisch",
    "Latein",
  ],

  Naturwissenschaften: [
    "Mathematik",
    "Physik",
    "Chemie",
    "Biologie",
    "Naturlehre",
    "Informatik",
    "Natur + Technik",
  ],

  Geisteswissenschaften: [
    "Geschichte",
    "Geografie",
    "Wirtschaft und Recht",
    "Philosophie",
    "Religion",
    "Pädagogik",
  ],

  "Kunst & Sport": [
    "Sport",
    "Musik",
    "Bildnerisches Gestalten",
    "Hauswirtschaft",
  ],
};

/**
 * =========================================================
 * ✅ SUBJECT LABELS (MOBILE)
 * =========================================================
 */
export const SUBJECT_LABELS = {
  Deutsch: "DE",
  Englisch: "EN",
  Französisch: "FR",
  Spanisch: "ES",
  Italienisch: "IT",
  Latein: "LA",

  Mathematik: "MA",
  Physik: "PH",
  Chemie: "CH",
  Biologie: "BI",
  Naturlehre: "NL",
  Informatik: "IN",
  "Natur + Technik": "NT",

  Geschichte: "GS",
  Geografie: "GG",
  "Wirtschaft und Recht": "WR",

  Philosophie: "PH",
  Religion: "RE",
  Pädagogik: "PP",

  Sport: "SP",
  Musik: "MU",
  "Bildnerisches Gestalten": "BG",
  Hauswirtschaft: "HW",

  "ICT Support": "ICT",
  LaP: "LAP",
  Lerncoaching: "LC",
};
